var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwCFunctIconsPencilOutlineBlackRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Outline",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pencil-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M79.9,15.32l4.78,4.78a4.49,4.49,0,0,1,0,6.36L30.21,80.93,14,86l5.07-16.21L73.54,15.32A4.49,4.49,0,0,1,79.9,15.32ZM76.73,28.05l4.77-4.77L76.72,18.5,72,23.27Zm-3.18,3.18-4.78-4.78L23,72.19l-2.17,7,7-2.17Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwCFunctIconsPencilOutlineBlackRgb);
export default __webpack_public_path__ + "static/media/PwC_Funct_Icons_Pencil_Outline_Black_RGB.e58f61511c74100e8c7a9fa16b8fc495.svg";
export { ForwardRef as ReactComponent };